import { render, staticRenderFns } from "./medicalType.vue?vue&type=template&id=7174759c&scoped=true&"
import script from "./medicalType.vue?vue&type=script&lang=js&"
export * from "./medicalType.vue?vue&type=script&lang=js&"
import style0 from "./medicalType.vue?vue&type=style&index=0&id=7174759c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7174759c",
  null
  
)

export default component.exports